var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"flex space-x-2 items-start mt-2",attrs:{"for":"confirm"}},[_c('input',{staticClass:"cursor-pointer appearance-none flex-shrink-0 border border-gray-300 rounded-sm",attrs:{"id":"confirm","type":"checkbox"},domProps:{"checked":_vm.checked},on:{"change":_vm.onChange}}),_c('div',[_vm._t("default"),_vm._t("error")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }